// extracted by mini-css-extract-plugin
export default {"menuText":"#c9ced4","menuActiveText":"#fff","subMenuActiveText":"#fff","menuBg":"#14171a","menuHover":"#14171a","subMenuBg":"#14171a","subMenuHover":"#14171a","sideBarWidth":"240px"};